import { render, staticRenderFns } from "./inventoryRecords.vue?vue&type=template&id=3974762f&scoped=true"
import script from "./inventoryRecords.vue?vue&type=script&lang=js"
export * from "./inventoryRecords.vue?vue&type=script&lang=js"
import style0 from "./inventoryRecords.vue?vue&type=style&index=0&id=3974762f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974762f",
  null
  
)

export default component.exports